import React from 'react';
import { useHistory } from 'react-router-dom';
import NAVerificationCode from './NAVerificationCode';
import { Context } from '../../Store/store';
import HttpRequest from '../../Services/HttpRequest';
import ApiRoutes from '../../Services/ApiRoutes';
import { devLog, overlay } from '../../utils/Helper';

const NAVCLogic = (props) => {
    const [state, dispatch] = React.useContext(Context);
    const history = useHistory();
    const forgot_token = props && props.history && props.history.location && props.history.location.state.forgot_token;

    const submitForm = (params) => {
        dispatch({ type: "SET_STATE", response: [], flash_message_show:false});
        overlay(true);
        params.append('forget_token',forgot_token)
        HttpRequest.makeRequest(
            ApiRoutes.loginVerifyCode.method,
            ApiRoutes.loginVerifyCode.end_point,
            params
        ).then((response) => {
            if(response.resCode === 200){
                overlay(false);
                dispatch({type:"SET_STATE", response:response, flash_message_show:true});
                setTimeout(() => {history.push({pathname:"/reset-pass",  state: { forgot_token: forgot_token }})},1000);               
            }else {
                dispatch({type:'SET_STATE', response:response, flash_message_show:true});
                overlay(false);
            }
        }).catch(err=>{
            devLog("error",err);
        });
    };

    React.useEffect(()=>{
        dispatch({type:'SET_STATE',response:[], flash_message_show:false});
    },[]);


    return(
        <>
            <NAVerificationCode submitForm={submitForm}/>
        </>
    );
}

export default NAVCLogic;